export default "__VITE_ASSET__673e1d43__"